/* global axios */
import ApiClient from '../ApiClient';

// The Messenger/Instagram connection guide. Text and images both come through
// the authenticated API (administrators of the allowed accounts only), so the
// images are fetched as blobs and shown through object URLs - a plain <img>
// request would carry no auth headers.
class TeletelMetaGuideAPI extends ApiClient {
  constructor() {
    super('meta-guide', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  show() {
    return axios.get(this.url);
  }

  image(name) {
    return axios.get(`${this.url}/images/${name}`, { responseType: 'blob' });
  }
}

export default new TeletelMetaGuideAPI();
